import { ICourse, IKDTKlass } from 'stores/courses'

interface ISchoolHeadProps {
  course: ICourse | IKDTKlass
}

const SchoolHead = ({ course }: ISchoolHeadProps) => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Course',
    name: course.title,
    description: course.subtitle,
    provider: {
      '@type': 'Organization',
      name: '멋쟁이사자처럼',
      url: 'https://bootcamp.likelion.net',
    },
    image: [course.image, course.imageM].filter(Boolean),
    startDate: course.startedAt,
    endDate: course.endedAt,
    timeRequired: `P${course.weeks}W`,
    teaches: course.title,
    datePublished: course.createdAt,
    author: {
      '@type': 'Organization',
      name: '멋쟁이사자처럼',
    },
    url: `https://bootcamp.likelion.net/school/${course.id}`,
  }

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(jsonLd),
        }}
      />
    </>
  )
}

export default SchoolHead
